<template>
    <div class="exam__main" :class="[{ pc: !mobile }, { mb: mobile }, { max_width_1200: !showExam }]">
        <div class="exam__content" v-if="!loading">
            <!-- Title -->
            <div class="exam__title" v-if="!mobile">
                <img src="../../../static/images/icon-st.jpg" />
                <span>{{ this.$route.query.courseName }}</span>
            </div>

            <!-- Nội dung -->
            <div class="content__">
                <div class="content__title">
                    <span>{{ $t("examBegins.notice_exam") }}</span>
                </div>
                <div class="content__rules">
                    <div class="content__rules__result" :class="[{ pc: !mobile }, { mb: mobile }]">
                        <div class="content__rules__result__title">
                            <p>{{ $t("new.title219") }}:</p>
                        </div>
                        <div class="content__rules__result__content">
                            <p class="color-red">{{ $t("new.title210") }}</p>
                        </div>
                    </div>
                    <div class="content__rules__result" :class="[{ pc: !mobile }, { mb: mobile }]">
                        <div class="content__rules__result__title">
                            <p>{{ $t("examBegins.introduce") }}:</p>
                        </div>
                        <div class="content__rules__result__content">
                            <p>1. {{ $t("examBegins.first") }}</p>
                            <p>2. {{ $t("examBegins.second") }}</p>
                        </div>
                    </div>
                    <div class="content__rules__result" :class="[{ pc: !mobile }, { mb: mobile }]">
                        <div class="content__rules__result__title">
                            <p>{{ $t("examBegins.rule") }}：</p>
                        </div>
                        <div class="content__rules__result__content">
                            <p>1. {{ $t("examBegins.one") }}</p>
                            <p>2. {{ $t("examBegins.two") }}</p>
                            <p>3. {{ $t("examBegins.three") }}</p>
                        </div>
                    </div>
                    <!-- TODO -->
                    <div class="content__rules__result" :class="[{ pc: !mobile }, { mb: mobile }]">
                        <div class="content__rules__result__title">
                            <p>{{ $t("examBegins.type") }}：</p>
                        </div>
                        <div class="content__rules__result__content">
                            <el-radio v-model="exam.type" :label="1">{{ $t("examBegins.full") }}</el-radio>
                            <el-radio v-model="exam.type" :label="0">{{ $t("examBegins.notFull") }}</el-radio>
                        </div>
                    </div>
                    <!-- TODO -->
                    <div class="content__rules__result pc">
                        <div class="content__rules__result__title" :class="[{ f60: mobile }]">
                            <p>{{ $t("examBegins.remain") }}：</p>
                        </div>
                        <div class="content__rules__result__content chuslo">
                            <p>{{ exam.restCount }}</p>
                        </div>
                    </div>
                    <div class="content__rules__result pc">
                        <div class="content__rules__result__title" :class="[{ f60: mobile }]">
                            <p>{{ $t("examBegins.current") }} :</p>
                        </div>
                        <div class="content__rules__result__content chuslo">
                            <p>{{ exam.recentScore }}</p>
                        </div>
                    </div>
                    <div class="content__rules__result pc">
                        <div class="content__rules__result__title" :class="[{ f60: mobile }]">
                            <p>{{ $t("examBegins.highest") }} :</p>
                        </div>
                        <div class="content__rules__result__content chuslo">
                            <p>{{ exam.maxScore }}</p>
                        </div>
                    </div>
                    <!-- <div class="content__rules__result pc">
                        <div class="content__rules__result__title text-show" :class="[{ f60: mobile }]">
                            <p>Hiển thị chữ Furigana: </p>
                        </div>
                        <div class="content__rules__result__content chuslo">
                            <input type="checkbox" :checked="isShowFurigana" v-on:input="toggleShowFuri()" />
                            <p>{{ isShowFurigana ? 'Có' : 'Không' }}</p>
                        </div>
                    </div> -->
                </div>
                <div class="content__action">
                    <button class="el-button form_btn login_button1 btn-login el-button--default is-round"
                        @click="goToTest(exam)">
                        {{ $t("examBegins.begin") }}
                    </button>
                    <button class="el-button form_btn login_button1 btn-login el-button--default is-round"
                        @click="back()">
                        {{ $t("examBegins.giveUp") }}
                    </button>
                </div>
            </div>

            <!-- Cpn: Làm bài thi -->
            <testPage :data="data" v-if="showExam" />
        </div>

        <!-- Loading -->
        <loading :showLoading="loading" />
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import loading from "@/components/loading/loading";
import testPage from "@/views/testPage/testPage";

export default {
    data() {
        return {
            loading: true,
            showExam: false,
            courseId: null,
            exam: {},
            data: {}
        };
    },
    components: {
        loading,
        testPage
    },
    created() {
        this.$autoLogin().then(
            () => {
                this.init();
            },
            () => {
                this.$router.push({
                    path: "/home",
                });
            }
        );
    },
    computed: {
        // Lấy dữ liệu từ store
        ...mapState({
            mobile: (state) => state.header.mobile,
            isShowFurigana: (state) => state.showFurigana.isShowFurigana
        }),
    },
    methods: {
        init: async function () {

            const self = this;

            // Mở loading
            this.loading = true;

            this.courseId = this.$route.query.courseId;

            // Lấy danh sách bài thi
            this.exam = await this.getPastExamInfo({ courseId: this.courseId });

            let redirect = this.$route.query.redirect;

            // Kiểm tra trạng thái bài thi
            if (redirect) {
                this.data = {
                    type: this.exam.type,
                    courseId: this.courseId,
                    courseName: this.$route.query.courseName,
                    isDoing: 1
                }

                // Mở bài thi
                this.showExam = false;
                this.$nextTick(() => {
                    this.showExam = true;
                });
            } else {
                if (this.exam.isTemp == 1) {
                    // isTemp =>  0: chưa thi, 1: đang thi

                    let message = [];
                    let h = this.$createElement;
                    message.push(h("p", null, window.vm.$i18n.t("new.title99")));
                    this.$confirm(h("p", null, message), window.vm.$i18n.t("js.hint"), {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                        cancelButtonText: window.vm.$i18n.t("js.cancel"),
                        cancelButtonClass: "btn-custom-cancel",
                        type: "",
                    }).then(() => {
                        this.data = {
                            type: this.exam.type,
                            courseId: this.courseId,
                            courseName: this.$route.query.courseName,
                            isDoing: 1
                        }

                        // Mở bài thi
                        this.showExam = false;
                        this.$nextTick(() => {
                            this.showExam = true;
                        });
                    }).catch(() => { });
                }
            }

            // Đóng loading
            this.loading = false;
        },

        // Lấy thông tin bài thi
        getPastExamInfo: function (data) {
            return new Promise((resolve, reject) => {
                this.$api
                    .post("/studyCourseQuestion/getPastExamInfo", {
                        courseId: data.courseId
                    })
                    .then((response) => {
                        let info = {
                            type: 1,
                            isTemp: response.data.isTemp != null ? parseInt(response.data.isTemp) : response.data.isTemp,
                            maxScore: response.data.maxScore != null && response.data.recentScore != '--' ? parseInt(response.data.maxScore) : '--',
                            passMarks: response.data.passMarks != null ? parseInt(response.data.passMarks) : response.data.passMarks,
                            recentScore: response.data.recentScore != null && response.data.recentScore != '--' ? parseInt(response.data.recentScore) : '--',
                            isCommit: response.data.recentScore == '--' ? true : false,
                            restCount: response.data.restCount != null ? parseInt(response.data.restCount) : response.data.restCount,
                            fullMarks: response.data.fullMarks != null ? parseInt(response.data.fullMarks) : response.data.fullMarks
                        };
                        resolve(info);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
            });
        },

        // Quay lại trang mục lục
        back: function () {
            let outlineInfo = {
                courseId: this.$route.query.courseId,
                courseName: this.$route.query.courseName,
            };
            if (this.$route.query.isCurriculumExam) {
                this.$router.push({
                    path: "/home/curriculumExam",
                    query: {
                        outlineInfo: JSON.stringify(outlineInfo),
                    },
                });
            } else {
                this.$router.push({
                    path: "/home/curriculum",
                    query: {
                        outlineInfo: JSON.stringify(outlineInfo),
                    },
                });
            }
        },

        // Đến trang thi
        goToTest: function (exam) {

            // Bạn không thể làm lại bài thi khi đang chấm điểm bài thi. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn tất.
            if (exam.isCommit) {
                this.$message.warning(window.vm.$i18n.t("js.lastExam"));
                return;
            }

            // Thi lại
            if (exam.restCount != 0 && parseInt(exam.isTemp) == 0) {

                let message = [];
                let h = this.$createElement;

                message.push(h("p", null, window.vm.$i18n.t("new.title37")));
                message.push(h("p", null, window.vm.$i18n.t("new.title38")));

                this.$confirm(h("p", null, message), window.vm.$i18n.t("js.hint"), {
                    confirmButtonText: window.vm.$i18n.t("js.confirm"),
                    cancelButtonText: window.vm.$i18n.t("js.cancel"),
                    cancelButtonClass: "btn-custom-cancel",
                    type: "",
                }).then(() => {
                    this.data = {
                        type: this.exam.type,
                        courseId: this.courseId,
                        courseName: this.$route.query.courseName,
                        examName: this.exam.examName,
                        isDoing: 0
                    }

                    // Mở bài thi
                    this.showExam = false;
                    this.$nextTick(() => {
                        this.showExam = true;
                    });
                }).catch(() => { });
                return;

            } if (exam.restCount == 0 && parseInt(exam.isTemp) == 0) {
                this.data = {
                    type: this.exam.type,
                    courseId: this.courseId,
                    courseName: this.$route.query.courseName,
                    examName: this.exam.examName,
                    isDoing: 0
                }

                // Mở bài thi
                this.showExam = false;
                this.$nextTick(() => {
                    this.showExam = true;
                });
                return;
            } else {
                this.data = {
                    type: this.exam.type,
                    courseId: this.courseId,
                    courseName: this.$route.query.courseName,
                    examName: this.exam.examName,
                    isDoing: 1
                }

                // Mở bài thi
                this.showExam = false;
                this.$nextTick(() => {
                    this.showExam = true;
                });
                return;
            }
        },

        toggleShowFuri: function () {
            this.handleToggleShow()
        },
        ...mapActions("showFurigana", ["handleToggleShow"]),
    },
};
</script>

<style scoped>
.color-red {
    color: red !important;
    font-size: 16px !important;
    font-weight: bold;
}

.max_width_1200 {
    max-width: 1200px;
}

.exam__main {
    margin: 20px auto;
    max-width: 1200px;
}

.exam__main.pc {
    width: 100%;
}

.exam__main.mb {
    width: 96%;
}

.exam__main .exam__content .content__ {
    border-radius: 10px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    margin-top: 10px;
}

.exam__main .exam__content .exam__title {
    display: flex;
}

.exam__main .exam__content .exam__title img {
    width: 36px;
}

.exam__main .exam__content .exam__title span {
    font-size: 24px;
    font-weight: 700;
    align-self: center;
    margin-left: 5px;
    color: #0071c5;
}

.exam__main .exam__content .content__ .content__title {
    height: 40px;
    background-color: #0071c5;
    border-radius: 10px 10px 0 0;
    text-align: center;
    line-height: 1.5;
}

.exam__main .exam__content .content__ .content__title span {
    font-size: 24px;
    font-weight: 700;
    color: #ffffff;
}

.exam__main .exam__content .content__ .content__rules .content__rules__result {
    margin-bottom: 10px;
}

.exam__main .exam__content .content__ .content__rules .content__rules__result.pc {
    display: flex;
}

.exam__main .exam__content .content__ .content__rules {
    padding: 2%;
}

.exam__main .exam__content .content__ .content__rules .content__rules__result .content__rules__result__title {
    flex: 20%;
}

.exam__main .exam__content .content__ .content__rules .content__rules__result.mb .content__rules__result__title {
    margin-bottom: 5px;
}

.exam__main .exam__content .content__ .content__rules .content__rules__result .content__rules__result__title p {
    font-size: 14px;
    font-weight: 700;
}

.exam__main .exam__content .content__ .content__rules .content__rules__result .content__rules__result__content {
    flex: 80%;
}

.exam__main .exam__content .content__ .content__rules .content__rules__result .content__rules__result__content p {
    font-size: 14px;
}

.text-show {
    color: red;
}

.content__action {
    text-align: center;
}

.content__action button {
    width: auto !important;
    min-width: 100px;
}

.f60 {
    flex: 60% !important;
}

.chuslo {
    color: #0071c5;
}
</style>



// WEBPACK FOOTER //
// src/views/exam/examBegins.vue